import styled from "styled-components";

export const BillingDiv = styled.div`
  width: 100%;
  display: flex;
  margin-top: 34px;
  overflow: auto;
  background-color: #ffffff;
  border-radius: 20px;
  flex-direction: column;
  height: 90%;
  .billing-selection {
    background-color: #fafafc;
    padding: 20px 40px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    height: calc(100% - 56px);
    .title {
      font-size: 20px;
      color: #3e3e5b;
    }
    .year-selection {
      margin-top: 20px;
      display: flex;
      width: 100%;
      justify-content: space-between;
      margin: 10px 20px;
      align-items: center;
      margin-top: 20px;
      &__year {
        font-size: 18px;
        color: #707582;
      }
    }
    .billing-info {
      max-height: calc(100% - 97px);
      display: flex;
      &__month-selection {
        justify-content: center;
        margin-top: 40px;
        /* display: grid;
          grid-template-columns: repeat(6, 1fr);  */
        display: flex;
        flex-wrap: wrap;
        gap: 1.5rem; /* espacio entre cajas */
        /* padding: 40px; */
        box-sizing: border-box;
        justify-items: center;
        align-items: center;
        max-width: 1200px;
        overflow: auto;
        margin: auto;
      }
    }
  }
  .billing-info {
    width: 100%;
    height: calc(100% - 60px);
    overflow: auto;
  }
  .footer {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 10px 20px;
    box-sizing: border-box;
    &__left {
      .button-period {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 36px;
        background-color: #f2f2f8;
        border-radius: 8px;
        color: #3e3e5b;
        font-size: 16px;
        cursor: pointer;
        white-space: nowrap;
        padding: 0 10px;
        &__close {
          margin-right: 20px;
          padding: 4px;
          font-size: 10px;
          color: #0c0aa2;
        }
      }
    }
  }
`;

export const BillingMonth = styled.div`
  width: 160px;
  height: 160px;
  background-color: ${({ selected, disabled }) =>
    disabled ? "#CFD3DD" : selected ? "#1168FF" : "#F2F2F8"};
  border: 2px solid #ffffff;
  border-radius: 14px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};
  color: ${({ selected }) => (selected ? "#FFFFFF" : "#3E3E5B")};
  .month-name {
    font-size: 20px;
  }
  .month-subtitle {
    font-size: 14px;
    text-align: center;
  }
`;
